import { EtapaIcon } from "./EtapaIcon";
import { RASTREO } from "@/constants/testIds";

// Badge que muestra la etapa actual de la unidad.
export const StageBadge = ({ etapa }) => {
  if (!etapa) return null;
  return (
    <span
      data-testid={RASTREO.detailStageBadge}
      className="inline-flex items-center gap-2 rounded-full bg-[var(--tc-accent-soft)] px-3.5 py-1.5 text-sm font-semibold text-[var(--tc-accent)]"
    >
      <EtapaIcon nombre={etapa.icono} size={16} strokeWidth={2.2} />
      {etapa.nombre}
    </span>
  );
};
